import { z } from 'zod'
import {
  CurrencyAmountSchema,
  ServiceRequestSchema,
  ServiceResponseSchema,
} from '@/validators/service.validator'

// ===============================================================
// CONFIG
// ===============================================================

export const ConfigResponseSchema = z.object({
  stbApiHost: z.string(),
  stbApiIsSecure: z.optional(z.boolean()),
  appClientId: z.string(),
  authToken: z.string(),
})

// ===============================================================
// MESSAGES
// ===============================================================

export const MessageVariantSchema = z.object({
  parameter: z.string(),
  value: z.string(),
})

export const MessageSchema = z.object({
  variants: z.optional(z.array(MessageVariantSchema)),
  code: z.string(),
  text: z.string(),
})

export const MessagesResponseSchema = z.object({
  messages: z.array(MessageSchema),
})

// ===============================================================
// USER CONFIG
// ===============================================================

export const UserConfigResponseSchema = z.object({
  isAdmin: z.boolean(),
})

// ===============================================================
// TRANSLATE TEXT
// ===============================================================

export const TranslateTextRequestSchema = z.object({
  text: z.string(),
  fromLanguage: z.string(),
  toLanguage: z.string(),
})

export const TranslateTextResponseSchema = z.object({
  translated: z.string(),
  language: z.string(),
})

export const TranslateTextApiRequestSchema = z.object({
  translateTextRequest: TranslateTextRequestSchema,
})

export const TranslateTextApiResponseSchema =
  TranslateTextResponseSchema.extend({})

// ===============================================================
// GENERATE AUDIO
// ===============================================================

export const GenerateAudioRequestSchema = z.object({
  text: z.string(),
  language: z.string(),
})

export const GenerateAudioRequestApiSchema = z.object({
  generateAudioRequest: GenerateAudioRequestSchema,
})

// ===============================================================
// BETSLIP INFO
// ===============================================================

export const EventMarketOutcomeSelectorSchema = z.object({
  eventId: z.string(),
  marketId: z.string(),
  outcomeId: z.string(),
})

export const BetslipLegSchema = z.object({
  selections: z.array(EventMarketOutcomeSelectorSchema),
})

export const BetslipInfoRequestSchema = ServiceRequestSchema.extend({
  stake: z.optional(CurrencyAmountSchema),
  betType: z.optional(z.string()),
  legs: z.optional(z.array(BetslipLegSchema)),
  betOption: z.optional(z.string()),
})

export const BetslipInfoResponseSchema = ServiceResponseSchema.extend({
  legs: z.array(z.any()),
})

export const BetslipInfoApiRequestSchema = z.object({
  betslipInfoRequest: BetslipInfoRequestSchema,
})

export const BetslipInfoApiResponseSchema = z.object({
  betslipInfoResponse: BetslipInfoResponseSchema,
})
